const SNIPPET_PREFIX = '___SNIPPET___';
const SNIPPET_POSTFIX = '___END___';

function urlFriendlyString(value) {
	return value.toLowerCase().trim().replaceAll(' ', '-');
}

function wrapSnippetId(value) {
	return `${SNIPPET_PREFIX}${value}${SNIPPET_POSTFIX}`;
}

const tagsToArray = (tags) => {
	return tags.split(',').length > 0 ? tags.split(',').map((t) => t.trim()) : [ tags.trim() ];
};

const arrayToTags = (tags) => {
	// console.log(tags);
	// return tags;
	return Array.isArray(tags) ? tags.join(', ') : tags;
};

export default { urlFriendlyString, tagsToArray, arrayToTags, SNIPPET_PREFIX, SNIPPET_POSTFIX, wrapSnippetId };
